/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('nodeModalAction', ['modalAction', '$rootScope', function (modalAction, $rootScope) {
        return function ($scope, attrs) {
            var
                result = modalAction($scope, angular.merge(attrs, {
                    resolve: {
                        element: function () {
                            return $scope.node || $scope.selectedNodes;
                        },
                        selectionCountSummary: function () {
                            return $scope.selectionCountSummary;
                        }
                    }
                }));
            
            result.then(function () {
                // Having selected node means operation was performed on a subnode and so contents must be reloaded.
                if (attrs['reloadCurrent']) {
                    _reloadCurrentNode();
                } else {
                    _reloadSubNodes();
                }
                
            });
            
            function _reloadSubNodes() {
                $rootScope.$broadcast('reload.dataTable');
            }
            
            function _reloadCurrentNode() {
                $scope.node.$get();
            }
            
            return result;
        };
    }]);


 
 
